import React from 'react';

import styles from './CountDown.module.css';

interface TimeLeftType {
  days: number;
  hrs: number;
  mins: number;
  secs: number;
}

interface Props {
  date: Date;
  numberSize?: string;
  reloadTimer?: Date;
  reloadCallBack?: () => void;
  reload?: boolean;
  includeDaysInHrs?: boolean;
  days?: boolean;
  hrs?: boolean;
  mins?: boolean;
  secs?: boolean;
  fontFamily?: string;
  displayFirstLetter?: boolean;
  bold?: boolean;
  fontSize?: boolean;
  delimiter?: string;
  color?: string;
}

const calculateTimeLeft = (endDate: Date) => {
  const difference = endDate.getTime() - Date.now();
  let timeLeft = { days: 0, hrs: 0, mins: 0, secs: 0 };

  if (difference > 0) {
    timeLeft = {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hrs: Math.floor((difference / (1000 * 60 * 60)) % 24),
      mins: Math.floor((difference / 1000 / 60) % 60),
      secs: Math.floor((difference / 1000) % 60),
    };
  }
  return timeLeft;
};

export const CountDown: React.FC<Props> = props => {
  const {
    date,
    numberSize = '55px',
    reloadTimer,
    reloadCallBack,
    reload = true,
    fontFamily,
    fontSize,
    displayFirstLetter,
    bold,
    delimiter,
    color,
  } = props;
  const [countDown, setCountDown] = React.useState<TimeLeftType>(
    calculateTimeLeft(date),
  );

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setCountDown(calculateTimeLeft(date));
      if (
        reload &&
        countDown.days === 0 &&
        countDown.hrs === 0 &&
        countDown.mins === 0 &&
        countDown.secs === 0
      ) {
        window.location.reload();
      }
      if (
        reloadTimer &&
        reloadCallBack &&
        reloadTimer.getTime() <= Date.now()
      ) {
        reloadCallBack();
      }
    }, 1000);
    return () => clearTimeout(timer);
  });

  const timerComponents: JSX.Element[] = [];

  Object.keys(countDown).forEach((interval, i) => {
    const intervalValue = countDown[interval as keyof TimeLeftType];
    if (props[interval as keyof TimeLeftType] ?? true) {
      timerComponents.push(
        <div className="flex flex-row" key={i}>
          {delimiter != null && timerComponents.length !== 0 && (
            <div className="mr-1">{delimiter}</div>
          )}
          <div
            key={interval}
            style={
              interval === 'secs'
                ? {
                    display: 'flex',
                    alignItems: 'flex-end',
                    fontFamily: fontFamily ?? 'Vanguard CF, monospace',
                    color: color != null ? color : 'white',
                  }
                : {
                    display: 'flex',
                    alignItems: 'flex-end',
                    marginRight: '0.25em',
                    fontFamily: fontFamily ?? 'Vanguard CF, monospace',
                    color: color != null ? color : 'white',
                  }
            }
          >
            <div
              style={{
                fontWeight: bold ?? true ? 'bold' : 'normal',
                ...((fontSize ?? true) && { fontSize: numberSize }),
                lineHeight: numberSize,
              }}
            >
              {(intervalValue > 9 ? '' : '0') +
                String(
                  (props.includeDaysInHrs ?? false) && interval === 'hrs'
                    ? intervalValue + countDown.days * 24
                    : intervalValue,
                )}
            </div>
            <div
              style={{
                ...((fontSize ?? true) && { fontSize: '14px' }),
                fontWeight: bold ?? true ? 'bold' : 'normal',
                lineHeight: numberSize,
              }}
            >
              {displayFirstLetter ?? false
                ? interval[0]
                : intervalValue === 0
                ? interval.substr(0, interval.length - 1)
                : interval}
            </div>
          </div>
        </div>,
      );
    }
  });

  return <div className={styles.countdown}>{timerComponents}</div>;
};
